import BaseNumberInput, {
  InputNumberProps as BaseInputNumberProps,
} from 'antd/lib/input-number'

export interface InputNumberProps extends BaseInputNumberProps {}

export const InputNumber = (props: InputNumberProps): JSX.Element => (
  <>
    <BaseNumberInput {...props} />
  </>
)
